import { AlertFactory } from 'alerts/Alert'
import { GetCurrentMember } from 'iam/SessionStore'
import JobStore from 'jobs/JobStore'
import { Id } from 'types/definitions'
import { ignore404 } from 'utils/error-util'
import Document from './Document'
import DocumentStore, {
  type AssignDocumentTypeRequest,
  type UpdateDocumentRequest,
} from './DocumentStore'
import { DocumentDetailsModalPorts } from './views/DocumentDetailsModal/ports'
import DocumentTypeStore from './DocumentTypeStore'

export class DocumentDetailsAdapter implements DocumentDetailsModalPorts {
  // Bound ports
  fetchTypes = this.documentTypeStore.fetchTypes.bind(this.documentTypeStore)
  documentTypes = this.documentTypeStore.types

  constructor(
    public getCurrentMember: GetCurrentMember,
    private documentTypeStore: DocumentTypeStore,
    private documentStore: DocumentStore,
    private jobStore: JobStore,
    public newAlert: AlertFactory,
  ) {}

  downloadDocument(document: Document) {
    this.documentStore.download(document, false)
  }

  async fetchLinkedJobs(document: Document) {
    // In order to show links, we need to fetch the related info.
    // We can assume that if the link exists on the document, that we have
    // permission to pull the underlying resource tied to it.
    await Promise.all(
      document.links.job.jobIds.map(
        async (jobId) => await this.jobStore.fetchJob(jobId).catch(ignore404),
      ),
    ).catch((err) => console.error(err))
  }

  updateDocument(document: Document, request: UpdateDocumentRequest) {
    return this.documentStore.updateDocument(Id.assert(document.id), request)
  }

  archiveDocument(document: Document) {
    return this.documentStore.archiveDocument(Id.assert(document.id))
  }

  assignType(document: Document, request: AssignDocumentTypeRequest) {
    return this.documentStore.assignType(Id.assert(document.id), request)
  }
}
